export default __webpack_public_path__ + "static/ios-logo-4-c3cf2d138c19b4e291a8c762518450e7.webp";